import React, { FC, useState, useMemo } from 'react'
import classes from './styles.module.scss';
import { formatDate } from '../../home/components/left-menu/info.component';
import { getImageById } from '../../../requests/public.request';
import { useTranslation } from 'react-i18next';
import { DownloadIcon, GlassIcon, ArrowLeftIcon } from '../../../assets/icons';
import Modal from '../../../components/modal/modal.component';

const baseClass = 'image-grid';

interface IProps {
    images: {
        IMAGE_AFTER: { id: number, date: string }[];
        IMAGE_CURRENT: { id: number, date: string }[];
    }
}

const ImageGrid: FC<IProps> = ({ images }) => {
    const { t } = useTranslation();

    // соберем все фото в один список
    const allImages = useMemo(() => {
        return [
            ...(images.IMAGE_AFTER || []),
            ...(images.IMAGE_CURRENT || [])
        ];
    }, [images]);

    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    const handleDownload = (file: { id: number, date: string }) => {
        const link = document.createElement('a');
        link.href = getImageById(file.id);
        link.setAttribute('download', 'фото.png');
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    const handleImageClick = (index: number) => {
        setSelectedIndex(index);
    }

    const prevImage = () => {
        if (selectedIndex === null) return;
        setSelectedIndex((prev) => (prev! - 1 + allImages.length) % allImages.length);
    };

    const nextImage = () => {
        if (selectedIndex === null) return;
        setSelectedIndex((prev) => (prev! + 1) % allImages.length);
    };

    return (
        <div className={classes[baseClass]}>
            {
                ['IMAGE_AFTER', 'IMAGE_CURRENT'].map((key) => {
                    const imageList = images[key as keyof typeof images];
                    if (!imageList || imageList.length === 0) return null;

                    return (
                        <div className={classes[`${baseClass}__image-block`]} key={key}>
                            <span>{t(`projects.${key}`)}</span>
                            <div className={classes[`${baseClass}__image-list`]} key={key}>
                                {imageList.map((image, idx) => {
                                    // индекс изображения в общем массиве
                                    const globalIndex = allImages.findIndex(img => img.id === image.id);
                                    return (
                                        <div className={classes[`${baseClass}__image-item`]} key={image.id}>
                                            <div className={classes[`${baseClass}__image-container`]}>
                                                <img src={getImageById(image.id)} alt={image.date} />
                                                <div
                                                    className={classes[`${baseClass}__image-overlay`]}
                                                    onClick={() => handleImageClick(globalIndex)}
                                                >
                                                    <GlassIcon />
                                                </div>
                                            </div>
                                            <span className={classes[`${baseClass}__image-bottom`]}>
                                                {formatDate(image.date)}
                                                <div
                                                    className={classes[`${baseClass}__image-download`]}
                                                    onClick={() => handleDownload(image)}
                                                >
                                                    <DownloadIcon />
                                                </div>
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })
            }
            {selectedIndex !== null && (
                <Modal
                    show={selectedIndex !== null}
                    handleClose={() => setSelectedIndex(null)}
                >
                    <div className={classes.photos__modal}>
                        <button className={`${classes.photos__nav} ${classes.left}`} onClick={prevImage}>
                            <ArrowLeftIcon />
                        </button>
                        <img src={getImageById(allImages[selectedIndex].id)} alt="Selected" />
                        <button className={`${classes.photos__nav} ${classes.right}`} onClick={nextImage}>
                            <ArrowLeftIcon />
                        </button>
                    </div>
                </Modal>
            )}
        </div>
    )
}

export default ImageGrid
